import OnboardingTourComponent from './OnboardingTourComponent';
import { getClientCode, getClientColor } from 'actions/ui/init/initSelectors';
import {
  isTourActive,
  getTourQueue
} from 'actions/onboarding/onboardingSelectors';
import {
  startTour,
  endTour,
  skipTour
} from 'actions/onboarding/onboardingActions';
import { changePage, setSearchText } from 'actions/accounts/users/usersActions';
import { getFullName } from 'actions/auth/login';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getLocale } from 'actions/language/selectors';
import { push } from 'react-router-redux';

// Connect the STATE to the props fed into the component.
export const mapStateToProps = (state) => ({
  isTourActive: isTourActive(state),
  tourQueue: getTourQueue(state),
  clientCode: getClientCode(state),
  locale: getLocale(state),
  navbarColor: getClientColor(state),
  fullName: getFullName(state)
});

// Connect ACTIONS to the props fed into the component.
export const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      startTour,
      endTour,
      skipTour,
      push,
      changePage,
      setSearchText
    },
    dispatch
  );
};

// Create higher-order component which feeds in specified props.
const OnboardingTourContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(OnboardingTourComponent);

export default OnboardingTourContainer;



// WEBPACK FOOTER //
// ./src/components/common/OnboardingTour/OnboardingTourContainer.js